import * as Actions from '../../../../redux/actions'

import React, { Component } from 'react'

import MenuMember from "../../Common/MenuMember.jsx"
import { PropTypes } from "prop-types"
import ScrollToTop from "../../Common/ScrollToTop"
import { connect } from 'react-redux'
import { Virtuoso } from 'react-virtuoso'
import { Backdrop, CircularProgress, makeStyles } from '@material-ui/core'
import { GetMuvBookings } from './booking.services'
import BookingItem from './BookingItem'


const useStyles = makeStyles((theme) => ({
    backdrop: {
        zIndex: theme.zIndex.drawer + 1,
        color: '#fff',
    },
}));


/* trip container component */
const MuvBookingsContainer_ = ({ member, pastTrips, futureTrips, screenSize, dreamTrips, app_menu_height, is_mobile, logo_height,
    uuid, getMemberAreaFutureTrips, switch_container, getMemberAreaDreamTrips, getMemberAreaPastTrips, lang }) => {


    const [bookings, setBookings] = React.useState()
    const [loadingBookings, setLoading] = React.useState()
    const classes = useStyles();


    let margin_left = 0
    let margin_right = 0
    let sizeW = 0
    let sizeH = 0
    let position = "sticky"
    let top_H = 180
    let font_size = "50"
    if (!isNaN(screenSize)) {
        margin_left = screenSize > 1200 ? (screenSize / 100 * 5) + 430 : (screenSize <= 768 ? 0 : (screenSize / 100 * 4) + 350)
        margin_right = (screenSize <= 768) ? 0 : (screenSize / 100 * 8.5)
        sizeW = screenSize - margin_left - margin_right - 80
        font_size = screenSize <= 768 ? 25 : 50
        sizeH = screenSize > 1025 ? 265 : (screenSize > 500 ? 265 : 265)
    }

    React.useEffect(() => {
        if (uuid) {
            const getData = async () => {
                setLoading(true)
                const res = await GetMuvBookings(uuid)
                setBookings(res ?? [])
                setLoading(false)
            }
            getData()
        }
    }, [uuid])

    return (

        <div style={{ minHeight: "800px", top: top_H, position: "relative", marginLeft: margin_left, marginRight: margin_right, backgroundColor: "#191919" }} className="padding_top_20">
            <Backdrop className={classes.backdrop} open={loadingBookings} >
                <CircularProgress color="inherit" />
            </Backdrop>

            <div style={{
                position: position, zIndex: "3",
                top: is_mobile ? 0 : (-Math.ceil(-app_menu_height / 2))
            }}>
                <div className="padding_top_10 padding_left_20 padding_right_20" style={{ backgroundColor: "#191919" }}>
                    <MenuMember />
                </div>
            </div>
            <div className={is_mobile ? "pl-1 pr-1" : "padding_left_40 padding_right_40"} style={{ paddingBottom: 100 }}>
                {<div className="padding_top_50 padding_125rem_lr_mobile"
                    style={{
                        font: font_size + "px/72px Futura Hv BT",
                        color: "#FFFFFF"
                    }}>My Bookings
                </div>}

                <div
                    style={{
                        marginTop: 40,
                        display: 'grid',
                        gridTemplateColumns: 'repeat(3, 1fr)',
                        gap: 20,
                    }}
                >
                    {bookings?.length > 0 ? [...(bookings || [])]
                        ?.sort((a, b) => new Date(b.created_at) - new Date(a.created_at))?.map((booking) => (
                            <div key={booking?.id}>
                                <BookingItem booking={booking} />
                            </div>
                        )) : <>
                        <div style={{
                            font: "24px/24px Futura Lt BT",
                            color: "#FFFFFF",
                            width: 500
                        }}>
                            No bookings saved
                        </div>
                    </>}
                </div>



                {/* {tripsEmpty && !loadingTrips &&
                    <p className="padding_top_50 padding_125rem_lr_mobile"
                        style={{
                            font: "24px/24px Futura Lt BT",
                            color: "#FFFFFF"
                        }}>
                        You haven't added any {switch_container} yet.
                    </p>
                } */}


                {/* <div className="padding_top_50 padding_125rem_lr_mobile"
                    style={{
                        font: "30px/30px Futura Hv BT",
                        color: "#FFFFFF"
                    }}>2025
                </div> */}


                <ScrollToTop />
            </div>
        </div>
    )
}

const mapStateToProps = state => {
    return {
        pastTrips: state.Member.memberArea.memberPastTrips,
        futureTrips: state.Member.memberArea.memberFutureTrips,
        dreamTrips: state.Member.memberArea.memberDreamTrips,
        screenSize: state.Setting.htmlBody.bodyClientWidth,
        switch_container: state.Member.switch_container,
        is_mobile: state.Setting.is_mobile,
        app_menu_height: state.Setting.appMenu.app_menu_height,
        uuid: state.Member.authModal.uuid,
        member: state.Member.memberArea.memberMuver,
        logo_height: state.Setting.appMenu.logo.height,
        lang: state.Setting.lang,
    }
};

const mapDispatchToProps = {
    getMemberAreaPastTrips: Actions.getMemberAreaPastTrips,
    getMemberAreaFutureTrips: Actions.getMemberAreaFutureTrips,
    getMemberAreaDreamTrips: Actions.getMemberAreaDreamTrips,
};


const MuvBookingsContainer = connect(mapStateToProps, mapDispatchToProps)(MuvBookingsContainer_)
export default React.memo(MuvBookingsContainer)
